import React, { useState, useRef, useEffect } from "react";
import "./Navbar.css";

const Navbar = () => {
  const [active, setActive] = useState("home");
  const [touchActive, setTouchActive] = useState(null);
  const [visible, setVisible] = useState(false);

  const indicatorRef = useRef(null);
  const navbarRef = useRef(null);

  // -------------------------------
  // SCROLL REVEAL ANIMATION
  // -------------------------------
  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          setVisible(true);
          observer.disconnect(); // animate once
        }
      },
      { threshold: 0.2 }
    );

    if (navbarRef.current) observer.observe(navbarRef.current);

    return () => observer.disconnect();
  }, []);

  // -------------------------------
  // CUSTOM SMOOTH SCROLL
  // -------------------------------
  const scrollToSection = (sectionId) => {
    const element = document.getElementById(sectionId);
    if (!element) return;

    const startPosition = window.pageYOffset;
    const targetPosition = element.offsetTop - 140;
    const distance = targetPosition - startPosition;
    const duration = 600;
    let startTime = null;

    document.documentElement.style.scrollBehavior = "auto";

    const easeInOutCubic = (t) =>
      t < 0.5 ? 4 * t * t * t : (t - 1) * (2 * t - 2) * (2 * t - 2) + 1;

    const animation = (currentTime) => {
      if (startTime === null) startTime = currentTime;
      const timeElapsed = currentTime - startTime;
      const progress = Math.min(timeElapsed / duration, 1);

      window.scrollTo(
        0,
        startPosition + distance * easeInOutCubic(progress)
      );

      if (timeElapsed < duration) {
        requestAnimationFrame(animation);
      } else {
        document.documentElement.style.scrollBehavior = "smooth";
      }
    };

    requestAnimationFrame(animation);
  };

  const handleClick = (section) => {
    setActive(section);
    scrollToSection(section);

    const el = document.querySelector(`a[href="#${section}"]`);
    moveIndicator(el);
  };

  const moveIndicator = (el) => {
    if (!indicatorRef.current || !el) return;

    const rect = el.getBoundingClientRect();
    const parentRect = el
      .closest(".navbar-links")
      .getBoundingClientRect();

    indicatorRef.current.style.width = rect.width + "px";
    indicatorRef.current.style.left =
      rect.left - parentRect.left + "px";
  };

  useEffect(() => {
    const sections = document.querySelectorAll("section[id]");

    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            setActive(entry.target.id);
            const el = document.querySelector(
              `a[href="#${entry.target.id}"]`
            );
            moveIndicator(el);
          }
        });
      },
      { threshold: 0.6 }
    );

    sections.forEach((section) => observer.observe(section));
    return () => observer.disconnect();
  }, []);

  const navItems = ["home", "about", "services", "portfolio"];

  return (
    <nav
      ref={navbarRef}
      className={`navbar ${visible ? "navbar-visible" : ""}`}
    >
      <div className="navbar-logo">
        <img src="https://res.cloudinary.com/dspelvbl1/image/upload/f_auto,q_auto/v1773091832/remzy_arts_2_tnrkk8.png" alt="RemzyArts Logo" className="logo-img" />
      </div>

      <ul className="navbar-links">
        <span ref={indicatorRef} className="active-indicator" />
        <div className="navbar-options">
          {navItems.map((item) => (
            <li key={item}>
              <a
                href={`#${item}`}
                className={`${active === item ? "active" : ""} ${
                  touchActive === item ? "touch-active" : ""
                }`}
                onClick={(e) => {
                  e.preventDefault();
                  handleClick(item);
                }}
                onTouchStart={() => setTouchActive(item)}
                onTouchEnd={() => setTouchActive(null)}
              >
                {item.toUpperCase()}
              </a>
            </li>
          ))}
        </div>
      </ul>

      <a href="https://wa.link/q7egxz">
        <div className="btn-wrapper">
          <button className="hire-me-btn">Hire Me</button>
        </div>
      </a>
    </nav>
  );
};

export default Navbar;
